import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=b3f184f6&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=b3f184f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f184f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3f184f6')) {
      api.createRecord('b3f184f6', component.options)
    } else {
      api.reload('b3f184f6', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=b3f184f6&scoped=true", function () {
      api.rerender('b3f184f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/Notifications.vue"
export default component.exports